export function getDate() {
  return new Date()
    .toISOString()
    .replace('T', ' ')
    .replace(/\.(\d{3})Z$/, (_, ms) => `,${ms}`)
}

export const timeToMinutes = (time) => {
  const [hour, minute] = time.split(':').map(Number)
  return hour * 60 + minute
}

export const parseIsoToMs = (iso) => {
  const normalized = /Z$|[+-]\d{2}:\d{2}$/.test(iso) ? iso : `${iso}Z`
  const ms = Date.parse(normalized)
  return Number.isNaN(ms) ? null : ms
}
